import '../vendor/jquery.paroller.js';

const $win = $(window);

function is_touch_device() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  };

  if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
    return true;
  }
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

$win.on('load', function() {
  if (!is_touch_device() && $win.width() > 1023) {
    $('.animate').paroller();
    $win.trigger('scroll');
  }
});

$win.on('scroll', function() {
  if (!is_touch_device() && $win.width() > 1023) {
    $win.trigger('resize');
  }
});



// WEBPACK FOOTER //
// ../assets/js/parallax.js